import { inject, Aurelia } from 'aurelia-framework';
import { PLATFORM } from 'aurelia-pal';
import { HttpClient, json } from 'aurelia-fetch-client';
import { adClientId, adTenantId, adApiClientId } from 'startup/environment';
import * as Msal from '@azure/msal-browser';

@inject(HttpClient, Aurelia)
export class AuthService {
    constructor(http, aurelia) {
        this.http = http;
        this.aurelia = aurelia;
        this.token = null;
    }

    isLoading = false;
    loginTime = null;

    get user() {
        return {
            token: window.localStorage.getItem('id_token'),
            expiresAt: window.localStorage.getItem('expires_at'),
            name: window.localStorage.getItem('name'),
            id: window.localStorage.getItem('id'),
            email: window.localStorage.getItem('email'),
            database: window.localStorage.getItem('db'),
            roleId: window.localStorage.getItem('roleId'),
            roleName: window.localStorage.getItem('roleName')
        }
    }

    _msalInstance = null;
    get msalInstance() {
        if (this._msalInstance == null) {
            const msalConfig = {
                auth: {
                    clientId: adClientId(),
                    authority: `https://login.microsoftonline.com/${adTenantId()}`,
                    redirectUri: window.location.origin + '/session',
                    postLogoutRedirectUri: window.location.origin + '/session',
                    mainWindowRedirectUri: window.location.origin + '/session'
                },
                cache: {
                    cacheLocation: 'localStorage'
                }
            }
    
            return new Msal.PublicClientApplication(msalConfig);
        }

        return this._msalInstance;
    }

    async login(redirect = true) {
        if (this.isAuthenticated()) {
            await this.getRole();
            return;
        }

        this.isLoading = true;

        const request = {
            scopes: [
                `api://${adApiClientId()}/access_as_user`
            ]
        }

        let loginSuccessful = false;
        try {
            const response = await this.msalInstance.acquireTokenSilent(request);
            console.log(response);
            this.setStorage(response);
            await this.addOrUpdateUserAccount();
            loginSuccessful = true;
            this.loginTime = Date.now();
            await this.getRole();
        } catch {
            const response = await this.msalInstance.acquireTokenPopup(request);
            console.log(response);
            this.setStorage(response);
            await this.addOrUpdateUserAccount();
            loginSuccessful = true;
            this.loginTime = Date.now();
            await this.getRole();
        }

        this.isLoading = false;

        if (redirect)
            this.aurelia.setRoot(PLATFORM.moduleName('roots/app/index'));
    }

    getRole = async () => {
        const response = await this.http.fetch('users/role');
        const role = await response.json();
        window.localStorage.setItem('roleId', role.id);
        window.localStorage.setItem('roleName', role.name);
    }

    addOrUpdateUserAccount = async () => {
        try {
            await this.http.fetch('users/add-or-update', { method: 'POST' });
        } catch {
            this.logout();
        }
    };

    setStorage(responseJson) {
        window.localStorage.setItem('id_token', responseJson.accessToken);
        window.localStorage.setItem('expires_at', responseJson.expiresOn);
        window.localStorage.setItem('name', responseJson.account.name);
        window.localStorage.setItem('id', responseJson.account.localAccountId);
        window.localStorage.setItem('email', responseJson.account.username);
        window.localStorage.setItem('db', 'live');
    }

    logout() {
        window.localStorage.removeItem('id_token');
        window.localStorage.removeItem('expires_at');
        window.localStorage.removeItem('name');
        window.localStorage.removeItem('id');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('db');
        window.localStorage.removeItem('roleId');
        window.localStorage.removeItem('roleName');
        window.location = '/';
    }

    isAuthenticated() {
        return new Date().getTime() < new Date(this.user.expiresAt).getTime();
    }
}